import { SortingOptionsSuffix } from '../constants/algolia';

const SORTING_OPTION_SUFFIXES = new Set<string>(Object.values(SortingOptionsSuffix));

/**
 * Only codes with an Algolia replica index can be sorted by. The PLP sorting list is the raw SAP CX
 * SOLR sort list, which can contain codes without a replica (e.g. `random`), and a `?sort=` URL
 * param can hold anything, including an empty string.
 */
export const isSortingOptionSuffix = (code?: string | null): code is SortingOptionsSuffix =>
  !!code && SORTING_OPTION_SUFFIXES.has(code);

/**
 * @returns the sorting a category preselects, `relevance` when it selects none or one without an Algolia replica
 */
export const findDefaultSortingSuffix = (
  options?: Array<{ code: string; selected?: boolean | null }> | null
): SortingOptionsSuffix => {
  const code = options?.find(option => option.selected && isSortingOptionSuffix(option.code))?.code;

  return isSortingOptionSuffix(code) ? code : SortingOptionsSuffix.RELEVANCE;
};
